import { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import Lightbox, {
  SlideImage,
  RenderSlideProps,
} from 'yet-another-react-lightbox';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Captions from 'yet-another-react-lightbox/plugins/captions';

import ImageGalleryCard from '../gallery/ImageGalleryCard';

import { GROUPED_GALLERY_IMAGES, GalleryImage } from './galleryImages';

import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import './GroupedGallery.css';

const GroupedGallery = () => {
  const [currentImages, setCurrentImages] = useState<GalleryImage[] | null>(
    null
  );
  const [open, setOpen] = useState(false);
  const [startIndex, setStartIndex] = useState(0);

  const handleCardClick = (images: GalleryImage[]) => {
    setCurrentImages(images);
    setStartIndex(0);
    setOpen(true);
  };

  return (
    <div className="container my-4">
      <Row xs={1} sm={2} md={3} lg={4} className="g-4">
        {GROUPED_GALLERY_IMAGES.map((group, idx) => (
          <Col key={idx}>
            <ImageGalleryCard
              images={group.images.map((img) => ({
                src: img.src,
                thumbnail: img.src,
                title: img.caption ?? '',
              }))}
              footerText={group.title}
              className="grouped-gallery-card"
            />
          </Col>
        ))}
      </Row>

      {open && currentImages && (
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={currentImages.map((img) => ({
            src: img.src,
            title: img.caption || '',
          }))}
          index={startIndex}
          plugins={[Thumbnails, Captions]}
          render={{
            slide: (props: RenderSlideProps<SlideImage>) => {
              const { slide } = props;
              return (
                <div className="grouped-gallery-slide-container">
                  <img
                    src={slide.src}
                    className="grouped-gallery-slide-image"
                    alt={typeof slide.title === 'string' ? slide.title : ''}
                  />
                  {slide.title && (
                    <div className="grouped-gallery-slide-caption">
                      {slide.title}
                    </div>
                  )}
                </div>
              );
            },
          }}
        />
      )}
    </div>
  );
};

export default GroupedGallery;
